import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { API_URL } from '../config';

const Products = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_URL}/api/public/products`)
      .then(res => res.json())
      .then(data => {
        setProducts(data);
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div className="pt-32 pb-24 text-center">Loading products...</div>;
  }

  return (
    <div className="pt-16 pb-24">
      <div className="bg-slate-900 text-white py-20 text-center">
        <h1 className="text-4xl md:text-5xl font-bold mb-4">Our Products</h1>
        <p className="text-slate-400 max-w-2xl mx-auto px-4">Explore our comprehensive range of electrical and electronic solutions.</p>
      </div>

      <div className="container mx-auto px-4 mt-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((product: any) => (
            <div key={product.id} className="bg-white rounded-lg shadow-lg overflow-hidden border border-slate-100 hover:shadow-xl transition-shadow">
              <div className="h-64 overflow-hidden">
                <img 
                  src={product.image || 'https://via.placeholder.com/400x300?text=No+Image'} 
                  alt={product.name} 
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.target as HTMLImageElement).src = 'https://via.placeholder.com/400x300?text=No+Image';
                  }}
                />
              </div>
              <div className="p-6">
                <span className="text-orange-600 text-sm font-semibold uppercase tracking-wider">{product.category}</span>
                <h3 className="text-xl font-bold text-slate-900 mt-2 mb-3">{product.name}</h3>
                <p className="text-slate-600 mb-4 text-sm line-clamp-2">{product.description}</p>
                
                {product.specs && (
                  <div className="mb-6 space-y-1">
                    {(() => {
                      try {
                        const specs = JSON.parse(product.specs);
                        if (Array.isArray(specs)) {
                          return specs.map((spec: string, idx: number) => (
                            <div key={idx} className="flex items-center text-sm text-slate-500">
                              <span className="w-1.5 h-1.5 bg-orange-500 rounded-full mr-2"></span>
                              {spec}
                            </div>
                          ));
                        }
                      } catch (e) {
                        return null;
                      }
                    })()}
                  </div>
                )}
                
                <Link to="/contact" className="inline-block text-orange-600 font-semibold hover:text-orange-700 transition-colors">
                  Enquire Now &rarr;
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Products;
